import { useState, useEffect } from 'react';
import { TaskStatus } from '../../services/TaskStatus';
import { WorkflowTasks } from '../../services/WorkflowTasks';

export const useInterviewInfo = (ticket) => {
    const [province, setProvince] = useState(null);
    const [returnType, setReturnType] = useState(null);
    const [clientType, setClientType] = useState(null);

    // TODO: add this to the interview completion
    const [primaryName, setPrimaryName] = useState(null);
    const [spouseName, setSpouseName] = useState(null);

    useEffect(() => {
        let taskCompletions = (ticket ? ticket.taskCompletionStates : []) || []
        let interviewTask = taskCompletions
            .find(x => x.workflowTaskId === WorkflowTasks.INTERVIEW_COMPLETED && x.status === TaskStatus.COMPLETE)

        if (interviewTask && interviewTask.completionData) {
            let interview = JSON.parse(interviewTask.completionData)
            setProvince(interview.Province);
            setReturnType(interview.IsCoupled
                ? 'coupled'
                : 'single')
            setClientType(interview.IsReturningCustomer
                ? 'returning'
                : 'new')
            setPrimaryName(interview.PrimaryName)
            setSpouseName(interview.SpouseName)
        } else {
            setProvince(null);
            setReturnType(null);
            setClientType(null);
            setPrimaryName(null);
            setSpouseName(null);
        }
        
    }, [ticket])

    return [returnType, clientType, province, primaryName, spouseName];
}
